import request from "@/utils/request.js";

// 新增联系管理
export function addRelate(data) {
    return request({
        url: "/website/relate/addRelate",
        method: "post",
        data: data
    });
}
